import { errorTypes } from "../types/errorTypes";
export function isPhone(_ref) {
  let {
    required,
    value,
    countryLocale
  } = _ref;
  // Enabled google phone lib support.
  const format = window.i18nUtils.getPhoneFormat();
  if (required && !value) {
    return errorTypes.required;
  }
  if (!required && !value) {
    return '';
  }
  return format(value, countryLocale).isValid ? '' : errorTypes.invalid;
}